import { create } from 'zustand';
import type { ReactNode } from 'react';

interface HeaderContentState {
  content: ReactNode | null;
  setHeaderContent: (content: ReactNode) => void;
  clearHeaderContent: () => void;
  /** Right-side header slot — a page's own next action, rendered beside the
   * guest header's "End Session" button (see MainLayout) rather than in place
   * of it, e.g. "back to the hub" on a results page. */
  actionContent: ReactNode | null;
  setHeaderActionContent: (content: ReactNode) => void;
  clearHeaderActionContent: () => void;
  height: number | null;
  bottomOffset: number | null;
  setHeaderMetrics: (metrics: { height: number; bottomOffset: number } | null) => void;
}

export const useHeaderContentStore = create<HeaderContentState>((set) => ({
  content: null,
  setHeaderContent: (content) => set({ content }),
  clearHeaderContent: () => set({ content: null }),
  actionContent: null,
  setHeaderActionContent: (content) => set({ actionContent: content }),
  clearHeaderActionContent: () => set({ actionContent: null }),
  height: null,
  bottomOffset: null,
  setHeaderMetrics: (metrics) =>
    set({ height: metrics?.height ?? null, bottomOffset: metrics?.bottomOffset ?? null }),
}));

export default useHeaderContentStore;
